import window from 'global/window';
import { OXYGEN_REDIRECT_URL_KEY } from './constants';
import logger from './logger';
import authLib from './pkce';

export const setLoginRedirects = (redirectUrl) => {
  try {
    // Set current URL in local storage to be redirected to after verify of new acct.
    window.sessionStorage.setItem(OXYGEN_REDIRECT_URL_KEY, redirectUrl ? JSON.stringify(redirectUrl) : JSON.stringify(document.location.href));
  } catch (e) {
    logger.debug('Failed setting OXYGEN_REDIRECT_URL_KEY: ', e);
  }
};

export const LoginClickHandler = (event, redirectUrl) => {
  setLoginRedirects(redirectUrl);
  if (Object.keys(authLib?.authClient).length) {
    authLib?.authClient?.loginWithRedirect();
  }
};
